import { defineMessages } from 'react-intl';

export const messages: {
	googleDocsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	googleSheetsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	googleSlidesLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	msExcelLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	msPowerpointLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	msWordLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	googleDocsLabel: {
		id: 'dynamic-cards-search-page.document-search-result.google-docs-label',
		defaultMessage: 'Docs',
		description:
			'Google Docs label shown as part of the metadata below the document name in the search results, for example "Docs • CA • Updated 2 hours ago"',
	},
	googleSlidesLabel: {
		id: 'dynamic-cards-search-page.document-search-result.google-slides-label',
		defaultMessage: 'Slides',
		description:
			'Google Slides label shown as part of the metadata below the document name in the search results, for example "Slides • CA • Updated 2 hours ago"',
	},
	googleSheetsLabel: {
		id: 'dynamic-cards-search-page.document-search-result.google-sheets-label',
		defaultMessage: 'Sheets',
		description:
			'Google Sheets label shown as part of the metadata below the document name in the search results, for example "Sheets • CA • Updated 2 hours ago"',
	},
	msWordLabel: {
		id: 'dynamic-cards-search-page.document-search-result.ms-word-label',
		defaultMessage: 'Word',
		description:
			'Microsoft Word label shown as part of the metadata below the document name in the search results, for example "Word • CA • Updated 2 hours ago"',
	},
	msPowerpointLabel: {
		id: 'dynamic-cards-search-page.document-search-result.ms-powerpoint-label',
		defaultMessage: 'PowerPoint',
		description:
			'Microsoft PowerPoint label shown as part of the metadata below the document name in the search results, for example "PowerPoint • CA • Updated 2 hours ago"',
	},
	msExcelLabel: {
		id: 'dynamic-cards-search-page.document-search-result.ms-excel-label',
		defaultMessage: 'Excel',
		description:
			'Microsoft Excel label shown as part of the metadata below the document name in the search results, for example "Excel • CA • Updated 2 hours ago"',
	},
});
